<script>
    import Design2021ApprenticeDataTable from '../../../common/design-2021-apprentice-data-table.vue';
    import apexcharts from 'vue-apexcharts';

    export default {
        name: 'design-2021-analytics-index-component',
        components: { apexcharts, Design2021ApprenticeDataTable },
        props: {
            schoolIn: {
                type: Object
            },
            educationLevels: {
                type: Array
            },
            analyticsTags: {
                type: Array
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: this.$t('common.actions')
                    }
                ],
                options: {
                    chart: {
                        type: 'pie'
                    },
                    labels: ['leerlingen in een project', 'passieve leerlingen'],
                    dataLabels: {
                        enabled: true,
                        formatter: (val, opts) => {
                            const index = opts.seriesIndex;
                            return opts.w.config.series[index];
                        }
                    },
                    responsive: [
                        {
                            breakpoint: 1200,
                            options: {
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 1400,
                            options: {
                                legend: {
                                    position: 'right'
                                }
                            }
                        }
                    ],
                    tooltip: {
                        enabled: true,
                        custom: this.handleToolTip
                    }
                }
            };
        },
        computed: {
            studentActivity() {
                let total = this.schoolIn.las_location?.students_count;
                let passiveStudents = total - this.schoolIn.billable_students_count;

                return [this.schoolIn.billable_students_count, passiveStudents];
            },
        },
        methods: {
            gotoGroup(group) {
                window.location.href = this.routes.adminGoToGroup(group.id)
            }
        }
    };
</script>

<template>
    <div class="apprentice-simple-card">
        <div class="analytics-charts">
            <apexcharts
                type="pie"
                height="350"
                :options="options"
                :series="studentActivity">
            </apexcharts>
        </div>
        <design2021-apprentice-data-table
            :items="schoolIn.groups"
            :fields="fields"
        >
            <template #cell(actions)="data">
                <div class="row-actions">
                    <b-button
                        class="btn-open"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('analytics.to_group')"
                        @click="gotoGroup(data.item)">
                    </b-button>
                </div>
            </template>
        </design2021-apprentice-data-table>
    </div>
</template>

<style scoped lang="scss">
.analytics-charts {
    max-width: 800px;
    margin: 0 auto map-get($grid-gutter-spacing, 'forty-two');
}
</style>